//src/app/features/payments/redirectionPages/cardSuccess/index.tsx
import { SuccessFancyIcon } from 'assets/icons';
import { CustomButton } from 'Components/Auth/CustomButton';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CardSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    const shouldRedirectToCheckout = JSON.parse(
      sessionStorage.getItem('shouldRedirectToCheckout') || 'false',
    );
    if (shouldRedirectToCheckout) {
      navigate('/dashboard/services/add-service');
    }
  }, []);

  return (
    <div className="  text-align-webkit-center mt-16 ">
      <SuccessFancyIcon />
      <p className=" py-10 font-extrabold  text-medium ">
        {' '}
        Card Added Successfully
      </p>
      <div className="w-1/3">
        <CustomButton
          text="Go Back to Payments"
          onClick={() => navigate(`/dashboard/payments`)}
        />
      </div>
    </div>
  );
}
